// @flow
import * as types from './types';

export function transformSpendingWatchListToRequestData(spendingWatchList: types.SpendingWatchList) {
  return {
    id: spendingWatchList.id,
    clientId: spendingWatchList.clientId,
    isDeleted: spendingWatchList.isDeleted,
    name: spendingWatchList.name,
    filterId: spendingWatchList.filterId,
    targetAmount: spendingWatchList.targetAmount,
    resetTargetAmount: spendingWatchList.resetTargetAmount,
    emoji: spendingWatchList.emoji,
  };
}

export function transformResponseToSpendingWatchLists(response: any) {
  return response.data.resources.map((data) => (
    types.mkSpendingWatchList({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      name: data.name,
      filterId: data.filterId,
      thisMonth: data.thisMonth,
      yearToDate: data.yearToDate,
      monthlyTrend: data.monthlyTrend,
      numMonthlyTrendMonths: data.numMonthlyTrendMonths,
      monthSpendingProjection: data.monthSpendingProjection,
      targetAmount: data.targetAmount,
      emoji: data.emoji,
      createdAt: data.createdAt,
    })
  ));
}
